"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import coinns from "@/public/images/buyvredit.png";
import type { HistoryItem } from "./sidebar-history";
import AfterPaymentSuccessModel from "./congraculation.jsx";
import { useArtifact } from "@/hooks/use-artifact";
import { useDispatch,useSelector } from "react-redux";
import {
  setIsPaymentSuccess, setUser_ai_limit, setActiveItem,setIsFreeLimit, setActiveNavItem
} from "@/store/mainSlice";
import { useRouter } from "next/navigation";

type UserDetail = {
  _id: string;
  name: string;
  email: string;
  // ai_limit: number;
  // is_free_limit?: boolean;
};
interface Props {
  show: boolean;
  handleClose: () => void;
  userDetail: UserDetail | null;
}

const BuyCreditsModal: React.FC<Props> = ({
  show,
  handleClose,
  userDetail,
}) => {
  const { setArtifact } = useArtifact();
  const dispatch = useDispatch()
  const router = useRouter()
  const [amount, setAmount] = useState<number>(4.99);
  const [calculatedValue, setCalculatedValue] = useState<number>(15);
  const [error, setError] = useState<string>("");
  const [showAfterPaymentPopup, setShowAfterPaymentPopup] = useState(false);
  const {user_ai_limit} = useSelector((state)=>state.main)

  const PAYMENT_GETKEY = process.env.NEXT_PUBLIC_PAYMENT_GETKEY;
  const PAYMENT_CHECKOUT = process.env.NEXT_PUBLIC_PAYMENT_CHECKOUT;
  const PAYMENT_VERIFICATION = process.env.NEXT_PUBLIC_PAYMENT_VERIFICATION;

  useEffect(() => {
    setCalculatedValue(Math.ceil(amount * 5));
  }, [amount]);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (
      value < 0 ||
      (e.target.value.startsWith("0") && e.target.value.length > 1)
    ) {
      setError("Invalid amount");
      setAmount(0);
      setCalculatedValue(0);
      return;
    }
    setError("");
    setAmount(value);
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (error || amount <= 0) {
      setError("Please enter a valid amount.");
      return;
    }
    // console.log(userDetail, "=====BuyCreditsModal==========userDetail");
    try {
      if (!userDetail) {
        console.error("User details not loaded yet.");
        return;
      }
      const dataSend = {
        uid: userDetail._id,
        amount: Number(amount),
        credit: calculatedValue,
        email: userDetail.email,
        currency: "USD",
      };

      sessionStorage.setItem("CreditCalculated", calculatedValue.toString());
      if (!PAYMENT_GETKEY || !PAYMENT_CHECKOUT) {
        throw new Error(
          "Missing PAYMENT_GETKEY/PAYMENT_CHECKOUT environment variable"
        );
      }
      // Get Razorpay key
      const keyRes = await fetch(PAYMENT_GETKEY);
      const keyData = await keyRes.json();
      const key = keyData.key;

      // Create order
      const orderRes = await fetch(PAYMENT_CHECKOUT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataSend),
      });

      if (!orderRes.ok) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        router.replace("/login");
        return;
      }

      const orderData = await orderRes.json();
      const order = orderData.order;
      const options = {
        key,
        amount: Number(amount) * 100,
        currency: "USD",
        name: "VARNZ",
        description: "Payment for services",
        image: `${process.env.NEXT_PUBLIC_APP_URL}/images/logo192.png`,
        order_id: order.id,
        prefill: {
          name: userDetail.name,
          email: userDetail.email,
        },
        notes: {
          PaymentFor: "Credits Purchased",
          Link: "https://varnz.ai",
          userId: userDetail._id,
          appId: "varnz.ai",
          appName: "varnz.ai",
        },
        theme: {
          color: "#121212",
        },
        handler: async (response: any) => {
          try {
            if (!PAYMENT_VERIFICATION) {
              throw new Error(
                "Missing PAYMENT_VERIFICATION environment variable"
              );
            }
            // console.log("paymenetete", response);
            dispatch(setIsPaymentSuccess(true))
            
            let paymentRes = await fetch(PAYMENT_VERIFICATION, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });

            let paymentDetails = {
              amount: Number(amount),
              credit: calculatedValue,
              newCredit: user_ai_limit + calculatedValue,
              paymentRes: response,
            };
            dispatch(setUser_ai_limit(user_ai_limit + calculatedValue))
            dispatch(setIsFreeLimit(false))

            setArtifact((old) => ({
              ...old,
              isPaymentSuccess: true,
              paymentDetails: paymentDetails,
            }));
            dispatch(setIsPaymentSuccess(false))

            

            // console.log("setShowAfterPaymentPopup", paymentRes);

            // setShowAfterPaymentPopup(true)

            // console.log("✅ Payment successful!", response);
          } catch (verifyError) {
            console.error("❌ Verification failed:", verifyError);
            setError("Payment verification failed. Please contact support.");
          }
        },
      };

      const razor = new (window as any).Razorpay(options);
      razor.open();
    } catch (err) {
      console.error("❌ Payment error:", err);
      setError("An error occurred during payment. Please try again.");
    } finally {
      handleClose();
    }
  };

  if (!show) return null;
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#181818] bg-opacity-60 backdrop-blur-[1px] px-4">
        <div className="w-full max-w-lg rounded-2xl border border-white/10 bg-accent dark:bg-neutral-900 shadow-2xl ring-1 ring-black/5">
          <div className="flex items-center justify-between gap-3 p-2 border-b dark:border-white/10 border-black/10">
            <div className="flex items-center gap-3">
              <div className="grid place-content-center size-12 rounded-xl bg-white/[0.03] ring-1 dark:ring-white/10 ring-black/10">
                <svg
                  viewBox="0 0 48 48"
                  className="size-7 text-black dark:text-neutral-200"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  aria-hidden="true"
                >
                  <rect
                    x="4"
                    y="12"
                    width="30"
                    height="20"
                    rx="3"
                    className="opacity-90"
                  />
                  <path d="M7 20h24" />
                  <circle cx="38" cy="28" r="8" />
                  <circle cx="41.5" cy="22" r="5.2" className="opacity-70" />
                </svg>
              </div>
              <h2 id="modal-title" className="text-xl font-semibold">
                Buy Credits
              </h2>
            </div>
            <button
              id="closeModal"
              // onClick={handleClose}
              onClick={() => {
                handleClose();
                // dispatch(setActiveItem("z-[40]"));
                dispatch(setActiveNavItem("z-[40]"));
                dispatch(setActiveItem("z-[40]"));
              }}
              className="rounded-lg p-2 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
            >
              <span className="sr-only">Close</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="size-5"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="p-6 space-y-5">
            <form onSubmit={handleSubmit}>
              <p
                id="modal-desc"
                className="text-sm leading-relaxed dark:text-neutral-300 text-black"
              >
                Every US Dollar gets you <b>5</b> credits. Minimum credits
                allowed to be purchased are <b>25</b> credits. Every credit
                earns you one prompt or query in all of our services — creating
                greeting cards, creating web pages, or future offerings.
              </p>
              <p className="text-xs dark:text-neutral-300 text-black mb-4 mt-4">
                Unused credits remain in your account for future use.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-end">
                <div className="sm:col-span-6">
                  <label className="block text-sm font-medium dark:text-neutral-300 text-black">
                    Amount (USD)
                  </label>
                  <div className="relative mt-1">
                    <span className="absolute inset-y-0 left-3 grid place-content-center pointer-events-none select-none text-neutral-400">
                      $
                    </span>

                    <input
                      type="number"
                      value={amount}
                      onChange={handleAmountChange}
                      onBlur={(e) => {
                          if (e.target.value < 4.99) {
                              setAmount(4.99)
                          }
                      }}
                      min={4.99}
                      required
                      placeholder="Enter amount"
                      // className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-300"

                      className="w-full tabular-nums rounded-xl dark:bg-neutral-800/80 bg-white leading-normal border border-white/10 pl-7 pr-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/30 placeholder:text-neutral-500"
                    />
                  </div>
                  <p
                    id="minNote"
                    className="mt-2 text-xs dark:text-neutral-300 text-black hidden"
                  >
                    Minimum purchase is 25 credits ($5.00).
                  </p>
                </div>
                <div className="sm:col-span-6">
                  <div className="">
                    <div className="text-sm font-medium tabular-nums">
                      <span id="priceText"> ${amount.toFixed(2)}</span>
                      <span className="text-neutral-400"> = </span>
                      <span id="creditsText">{calculatedValue}</span>{" "}
                      Credits/Prompts
                    </div>
                    <p className="mt-1 text-xs dark:text-neutral-300 text-black">
                      You will get <span id="creditsText2">25</span> credits
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-3 mt-4">
                <button
                  id="payBtn"
                  className="w-full rounded-xl dark:bg-white bg-black dark:text-neutral-900 text-white font-medium py-3 dark:hover:bg-neutral-200  hover:bg-white hover:text-black transition-colors"
                  onClick={handleSubmit}
                >
                  Pay Now
                </button>
                <p className="text-[11px] dark:text-neutral-300 text-black text-center">
                  Secure checkout
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showAfterPaymentPopup && (
        <AfterPaymentSuccessModel
          open={true}
          close={() => setShowAfterPaymentPopup(false)}
        />
      )}
    </>
  );
};

export default BuyCreditsModal;
